import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {EXPIRATION_EXERCISE_ASSIGNMENT_4} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const ExpirationExerciseAssignment4 = "tfExpirationExerciseAssignment4Question";

export function expirationExerciseAssignment4() {
    return {
        templateUrl: "app/quiz/fxe/questions/ExpirationExerciseAssignment4.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ExpirationExerciseAssignment4Controller
    };
}

export class ExpirationExerciseAssignment4Controller extends FxeQuizQuestionController {
    public config = EXPIRATION_EXERCISE_ASSIGNMENT_4;
}
